import React from 'react'
import {Link, withRouter} from 'react-router-dom'
import {SignInLayout} from './SignInLayout'
import {Button} from 'startlibs/lib/components'
import {withForm, Errors, Form, TextInput} from 'startlibs/lib/form'
import {formFetch} from 'startlibs'
import {getAccount,setNotifications} from '../reducers'
import {connect} from 'react-redux'
import {buildValidation, confirmPasswords, minLength, required, responseFailure} from '../lib/validation'
import {FieldRequirements} from './SignUp'

@withForm(formFetch)
@withRouter
@connect(undefined,{getAccount,setNotifications})
class RedefinePasswordContent extends React.Component {

  onSuccess = () => {
    localStorage.setItem('hasLogged', 'true');
    this.props.getAccount().then(()=>this.props.history.push("/"))
    this.props.setNotifications(["Changes saved successfully"])
  }

  getKey = () => this.props.match.params.key

  preValidation = buildValidation({
    confirmPassword: confirmPasswords("password"),
    password:[required,minLength(6)]
  },
    ({password}) => ({key:this.getKey(),newPassword:password})
  )
  onFailure = responseFailure(this.props.form,()=>0)

  render() {
    const {form} = this.props
    return (
      <div>
        <div className="opening-section">
          <h1>Define new password</h1>
          <h3>Enter and confirm your new password below</h3>
        </div>
        <Form form={form}
              onFailure={this.onFailure}
              preValidation={this.preValidation} url="/api/account/reset-password/finish" onSuccess={this.onSuccess}>
          <TextInput
            form={form}
            type="password"
            path="password"
            label="New password:"
            placeholder="Enter your new password"
          />
          <TextInput
            form={form}
            type="password"
            path="confirmPassword"
            label="Confirm new password:"
            placeholder="Confirm your new password"
          />
          <FieldRequirements>
            Your password shall contain at least 6 characteres.
          </FieldRequirements>
          <div className="form-actions">
            <Button type="submit" highlight isLoading={form.isLoading}>Update and sign in</Button>
          </div>
          <Errors form={form}/>
        </Form>
      </div>
    )
  }
}

export function RedefinePasswordFooter() {return (<div className="signup-question"><span>Remember your password?</span><Link className="button outline" to="/">Sign in</Link></div>) };

export const RedefinePassword = () => <SignInLayout Content={RedefinePasswordContent} Footer={RedefinePasswordFooter} />



// WEBPACK FOOTER //
// ./src/javascripts/signin/RedefinePassword.jsx